import React from "react";
import Calendar from "./objCalTest";
import Calendar2 from "./objCalTest2";
import Cron from "./subPages/cron";
import Planner from "./subPages/objPlanner";
import Invoices from "./reporting/invoices";
import PdView from "./subPages/objPd";
import Admin from "./subPages/admin";
//import * as chakra from "@chakra-ui/react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
} from "@chakra-ui/react";

import {
  HamburgerIcon,
  ChevronDownIcon,
  LinkIcon,
  CalendarIcon,
} from "@chakra-ui/icons";
import {
  MdCommute,
  MdOutlineArrowBackIosNew,
  MdOutlineArrowForwardIos,
  MdSettingsBackupRestore,
  MdFactCheck,
  MdSchool,
} from "react-icons/md";

import Intake from "./subPages/intake/intake";

import urlExist from "url-exist";
import io from "socket.io-client";
import logoShortCourses from "../imgs/logoCourses.png";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

import logo from "../imgs/tdt_logo_300px.png";
import microsoft from "../imgs/microsofticon.png";

import * as security from "../crypto";
import * as dc from "../lucy/dynamicContent";

var config_users = [
  "Brett Roberts",
  "David Zhang",
  "System Admin",
  "Henry Wang",
  "Shannon Setter",
  "Jessica Alankalee",
];

var account_users = [
  "Brett Roberts",
  "David Zhang",
  "System Admin",
  "Jessica Alankalee",
  "Buddhike Wijayathilake",
  "Hongbin Zhang",
  "Mike Hatfield",
  "Henry Wang",
  "Helene McAlpine",
  "Debi Pearce",
  "Dilini Ranathunga",
  "Larry Conway",
  "Jennifer Reddick",
  "Sharon Knight",
  "Toni West",
  "Mark White",
  "Shannon Setter",
];

var general_admin_access = [
  "David Zhang",
  "Brett Roberts",
  "Gary Buckeridge",
  "Phil Hadrian",
  "Helene McAlpine",
  "Jennifer Reddick",
  "Nicole Roberts",
  "Toni West (For Portal)",
  "Toni West",
  "System Admin",
  "Simon Prior",
  "Bendigo ",
  "Gabor Stumpf",
  "Henry Wang",
  "Amrinder Singh",
  "Bendigo Trainer",
  "Jessica Alankalee",
  "Mike Hatfield",
  "Rodney Briant",
  "Buddhike Wijayathilake",
  "Hongbin Zhang",
  "Debi Pearce",
  "Dilini Ranathunga",
  "Larry Conway",
  "Rob Wade",
  "Madi Dunstone",
  "Kim Waight",
  "Sharon Knight",
  "Ridetek Admin",
  "Mark White",
  "Adam Clarke",
  "Niluka VonHagt",
  "Krystle Patterson",
  "Louise Bisognin",
  "Kristy Clark",
  "Shaun Fincham",
  "Lilly Roberts",
  "Ashley Harvey",
  "Jessica.R Russell",
  "Charles Cai",
  "Sharen Kemp",
  "Julie Perry",
  "Linda Gates",
  "Alistair Roberts",
  "Martha Rizkallah",
  "Shannon Setter",
];

var showCase = new Map();

for (var c1 in config_users) {
  showCase.set(config_users[c1]);
}

for (var c2 in account_users) {
  showCase.set(account_users[c2]);
}

for (var c3 in general_admin_access) {
  showCase.set(general_admin_access[c3]);
}

/*
branches:
Hallam
Bendigo
Sunshine
Ballarat
Dandenong
Carrum Downs
Sale
Ridetek*/

//import io from "socket.io-client";
//import { objCourse } from "../objs.js";

//http://10.8.0.1:18125/socket.io/?EIO=4&transport=polling&t=Ny0FJUV

var ioLocation = "https://tdtplanner.com:4433";
//var ioLocation = "http://localhost:18124";

var testing = false;
var liURl =
  "https://login.microsoftonline.com/611dd736-2657-4031-bd82-ec126b5ab8fb/oauth2/v2.0/authorize?client_id=0ddf86fd-3cde-4082-bed4-eaf32bbc4a16&redirect_uri=https%3A%2F%2Ftdtplanner.com%2Fwork%2F&response_type=token&scope=https%3A%2F%2Fgraph.microsoft.com%2FUser.Read&state=bctiemltl66d5937cobc2fkk80";

if (testing) {
  liURl =
    "https://login.microsoftonline.com/611dd736-2657-4031-bd82-ec126b5ab8fb/oauth2/v2.0/authorize?client_id=0ddf86fd-3cde-4082-bed4-eaf32bbc4a16&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fwork%2F&response_type=token&scope=https%3A%2F%2Fgraph.microsoft.com%2FUser.Read&state=bctiemltl66d5937cobc2fkk80";
  ioLocation = "http://localhost:18124";
}

var chatSocket = io.connect(ioLocation);

var socket = io.connect("http://10.8.0.1:18125");

//open buttons

var lstOpen = [false, false];

var menuBtnWidth = "100px";
var menuBtnHeight = "60px";

class WindowCourse extends React.Component {
  state = {
    loginUrl:
      "https://login.microsoftonline.com/611dd736-2657-4031-bd82-ec126b5ab8fb/oauth2/v2.0/authorize",
    appid: "0ddf86fd-3cde-4082-bed4-eaf32bbc4a16",
    //local
    /*loginRedirect:
      "https://login.microsoftonline.com/611dd736-2657-4031-bd82-ec126b5ab8fb/oauth2/v2.0/authorize?client_id=0ddf86fd-3cde-4082-bed4-eaf32bbc4a16&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fwork%2F&response_type=token&scope=https%3A%2F%2Fgraph.microsoft.com%2FUser.Read&state=bctiemltl66d5937cobc2fkk80",
*/
    //online
    loginRedirect: liURl,

    token: "",
    data: {},
    userPass: "",
    loggedIn: false,
    vpnData: "",
    ping: false,
    weekday: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    weekNumber: 0,
    currentDay: "",
    resourceData: {},
    /*trainerTimeTable: [],
    trainerStudentse: [],
    allocatedResource: [],
    btnTrainersColor: "red",
    */

    selectedWindow: "",
    TruckPendingReports: [],
    connectedToCloud: "Press to refresh",
    btnCloudPlanner: "red",
  };

  componentDidMount() {
    const { weekday } = this.state;

    //const queryParams = new URLSearchParams(window.location.search);
    //const id = queryParams.get("id");
    //console.log(id);

    //console.log(window.location.href);
    //console.log(window.location.pathname);
    //console.log(window.location.origin);

    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var pdPass = urlParams.get("pd");

    if (pdPass) {
      localStorage.setItem("hotPass", "pd");
    }

    try {
      var link = window.location.href;
      var splitLink = link.split("#access_token=");
      var query = splitLink[1].split("&");
      //console.log(query);
      var token = query[0];
      this.makeGetRequest(token);

      /*var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var pdPass = urlParams.get("pd");
      alert(pdPass);*/
    } catch {}

    var currentdate = new Date();
    var oneJan = new Date(currentdate.getFullYear(), 0, 1);
    var numberOfDays = Math.floor(
      (currentdate - oneJan) / (24 * 60 * 60 * 1000)
    );
    var result = Math.ceil((currentdate.getDay() + 1 + numberOfDays) / 7);
    /*console.log(
      `The week number of the current date (${currentdate}) is ${result}.`
    );*/
    const d = new Date();
    let day = weekday[d.getDay()];
    this.setState({ weekNumber: result, currentDay: day });
    /*$_SESSION['uname'] = $rez["displayName"];s
      $_SESSION['id'] = $rez["id"];
      $_SESSION['givenName'] = $rez["givenName"];
      $_SESSION['surname'] = $rez["surname"];
      $_SESSION['mail'] = $rez["mail"];*/

    //setInterval(this.pingVpnTimer, 1000);

    /*setInterval(() => {
      this.setVpnStatus();
    }, 1000);*/
  }

  async pingCheckVpnAccess(fullUrl) {
    try {
      await axios.head(fullUrl);
      return true;
    } catch (error) {
      if (error.response.status >= 400) {
        return false;
      }
    }
  }

  async makeGetRequest(token) {
    const res = await axios.get("https://graph.microsoft.com/v1.0/me/", {
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    });

    //console.log(res["data"]);
    var data = res["data"];

    if (data["mail"].includes("@tdt.edu.au")) {
      this.loadSocket(data);

      var linkHotPass = localStorage.getItem("hotPass");
      if (linkHotPass == "pd") {
        this.btnPressMenu(4);
      }

      this.setState({ token: token, data: data, loggedIn: true });
    }

    //return res["data"];
  }

  async loadSocket(data) {
    var publicKey = uuidv4();
    var p1 = uuidv4();
    var p1UserData = JSON.stringify(data);
    //(secretKey, text)
    var p1Encrypted = security.encrypt(p1, p1UserData);
    var sendServer = JSON.stringify({ p1: p1, ud: p1Encrypted });
    var publicEncrypt = security.encrypt(publicKey, sendServer);
    //console.log(data);
    //var ioLocation = "https://tdtplanner.com";

    chatSocket.emit("publicKey", publicKey);
    chatSocket.emit("login", publicEncrypt);
    chatSocket.on("ready", (data) => {
      var passData = "id=";
      var j = JSON.parse(data);
      passData += j["id"];
      passData += "&session=" + j["session"];
      this.setState({ userPass: passData });
    });

    chatSocket.on("ready", (data) => {
      var passData = "id=";
      var j = JSON.parse(data);
      passData += j["id"];
      passData += "&session=" + j["session"];
      this.setState({ userPass: passData });
    });

    chatSocket.on("vpnData", (data) => {
      var vData = security.decrypt(publicKey, data);
      this.save("vpnaccess.ovpn", vData);
      //this.setState({ vpnData: vData });
    });

    socket.on("connect", function () {
      console.log("vpn");
      this.setState({ ping: true });
    });

    socket.on("disconnect", () => {
      console.log("novpn");
      this.setState({ ping: false });
    });

    if (showCase.has(data["givenName"] + " " + data["surname"])) {
      var jString = JSON.stringify({
        firstname: "Matthew",
        lastname: "Macdonald",
        type: "trainer",
      });
      //alert("yes");
      //Rinaldi
      chatSocket.emit("searchResource", jString);
    } else {
      var jString = JSON.stringify({
        firstname: data["givenName"],
        lastname: data["surname"],
        type: "trainer",
      });
      //alert("yes");
      //Rinaldi
      chatSocket.emit("searchResource", jString);
    }

    //this.save("wow.txt", "hollycrap");

    //chatSocket.emit("login", data);

    //const res = await axios.get("https://geolocation-db.com/json/");
    //var jData = JSON.stringify(res.data);
    //chatSocket.emit("publicData", jData);
  }

  async btnOldCoursePlanner() {
    const { data } = this.state;

    if ("displayName" in data) {
      var checkLinked = await axios.get("http://localhost:8123/check");
      var checkData = checkLinked["data"];

      if (checkData == "Hello World!") {
        //console.log(data);
        //console.log(data["displayName"]);
        //var cpLink = "http://localhost/app/index.php?";
        //var cpLink = "http://10.66.66.1/app/index.php?";
        var cpLink = "http://localhost:801/app/index.php?";
        cpLink += "displayName=" + data["displayName"];
        cpLink += "&id=" + data["id"];
        cpLink += "&givenName=" + data["givenName"];
        cpLink += "&surname=" + data["surname"];
        cpLink += "&mail=" + data["mail"];
        window.open(cpLink, "_blank").focus();
        this.setState({ btnCloudPlanner: "teal" });
      } else {
        this.setState({ btnCloudPlanner: "teal" });
      }
    } else {
      this.setState({ btnCloudPlanner: "teal" });
    }
  }

  btnGetVPN() {
    chatSocket.emit("getVpn", "hello");
  }

  save(filename, data) {
    const blob = new Blob([data], { type: "text/csv" });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const elem = window.document.createElement("a");
      elem.href = window.URL.createObjectURL(blob);
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  }

  btnTrainers(firstname, lastname) {
    //console.log("trainers " + firstname);
  }

  checkUserPermission(list, user) {
    for (var i in list) {
      if (list[i] == user) {
        return true;
      }
    }
    return false;
  }

  adminUsersBtns() {
    const { data } = this.state;
    var user = data["givenName"] + " " + data["surname"];

    var found = this.checkUserPermission(config_users, user);
    if (found) {
      return (
        <HStack>
          <Menu>
            <MenuButton
              h="60px"
              colorScheme="teal"
              as={Button}
              rightIcon={<ChevronDownIcon />}
            >
              Testing
            </MenuButton>
            <MenuList>
              <MenuItem onClick={() => this.btnPressMenu(400)}>
                show intake interface (33% done)
              </MenuItem>
            </MenuList>
          </Menu>
          <Admin chatSocket={chatSocket} />
        </HStack>
      );
    } else {
      return <></>;
    }
    //account_users
  }

  accountUsersBtns() {
    const { data } = this.state;
    var user = data["givenName"] + " " + data["surname"];

    var found = this.checkUserPermission(account_users, user);
    if (found) {
      var lst = [
        <WrapItem>
          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              h="60px"
              colorScheme="teal"
            >
              General
            </MenuButton>
            <MenuList>
              <MenuItem onClick={() => this.btnPressMenu(1)}>
                <Icon as={MdSettingsBackupRestore} w={8} h={8} />
                Cron
              </MenuItem>
              <MenuItem onClick={() => this.btnPressMenu(3)}>
                <Icon as={MdFactCheck} w={8} h={8} />
                Sort invoices
              </MenuItem>
            </MenuList>
          </Menu>
        </WrapItem>,
      ];
      return lst;
    } else {
      return <></>;
    }
    //account_users
  }

  generalAdminBtns() {
    const { data } = this.state;
    var user = data["givenName"] + " " + data["surname"];
    var found = this.checkUserPermission(general_admin_access, user);
    if (found) {
      var lst = [
        <WrapItem>
          <Button
            colorScheme="red"
            w="100px"
            h="60px"
            onClick={() => this.btnPressMenu(2)}
          >
            <Box>
              <Center>
                <CalendarIcon />
              </Center>
              <Center>New Planner</Center>
              <Center>construction</Center>
            </Box>
          </Button>
        </WrapItem>,
      ];
      return lst;
    } else {
      return <></>;
    }
  }

  /*,
        <WrapItem>
          <dc.SlidePanel
            key={uuidv4()}
            id={1}
            btnOpenStatus={this.btnOpenStatus}
            isOpen={lstOpen[1]}
            size="full"
            content={<Cron />}
            //id={uniBtnDay}
            parentCallback={this.handleCallback}
            testing={false}
            side="top"
            btn1content={
              <Box>
                <Center>
                  <Icon as={MdSettingsBackupRestore} w={8} h={8} />
                </Center>

                <Center>Cron</Center>
              </Box>
            }
            btn1width="100px"
            btn1height="100px"
            btn1cs="teal"
            btn2content="Back"
          />
        </WrapItem>,*/

  btnOpenStatus(status, id) {
    //console.log(status, id);
    lstOpen[id] = status;
  }

  showSelectedWindow() {
    const {
      selectedWindow,
      trainerTimeTable,
      trainerStudentse,
      allocatedResource,
      data,
    } = this.state;

    var user = data["givenName"] + " " + data["surname"];

    if (selectedWindow == "trainers") {
      return (
        <Calendar2
          firstname={data["givenName"]}
          lastname={data["surname"]}
          chatSocket={chatSocket}
          /*reqTrainerData={this.btnTrainers}
          trainerTimeTable={trainerTimeTable}
          trainerStudentse={trainerStudentse}
          allocatedResource={allocatedResource}*/
        />
      );
    } else if (selectedWindow == "cron") {
      return <Cron chatSocket={chatSocket} />;
    } else if (selectedWindow == "newplanner") {
      return <Planner chatSocket={chatSocket} />;
    } else if (selectedWindow == "sortInvoices") {
      return <Invoices chatSocket={chatSocket} />;
    } else if (selectedWindow == "showPD") {
      return <PdView chatSocket={chatSocket} user={user} />;
    } else if (selectedWindow == "showIntakeInterface") {
      return <Intake />;
    }
  }

  btnPressMenu(id) {
    const { btnTrainersColor, selectedWindow } = this.state;

    if (id == 0) {
      if (btnTrainersColor == "teal") {
      }
      this.setState({ selectedWindow: "trainers" });
    } else if (id == 1) {
      this.setState({ selectedWindow: "cron" });
    } else if (id == 2) {
      this.setState({ selectedWindow: "newplanner" });
    } else if (id == 3) {
      this.setState({ selectedWindow: "sortInvoices" });
    } else if (id == 4) {
      this.setState({ selectedWindow: "showPD" });
    } else if (id == 400) {
      this.setState({ selectedWindow: "showIntakeInterface" });
    }
  }

  render() {
    //console.log(this.getCourseName(119));
    const {
      weekNumber,
      loginRedirect,
      data,
      userPass,
      loggedIn,
      ping,
      currentDay,
      trainerTimeTable,
      trainerStudentse,
      allocatedResource,
      btnTrainersColor,
      openStatus,
      content,
      connectedToCloud,
      btnCloudPlanner,
    } = this.state;
    //console.log(ping);

    var loginIframe = (
      <Box w="100vw">
        <Box w="100%">
          <Box w="100%">
            <Center w="100%">
              <Image src={logo} />
            </Center>
          </Box>

          <Center w="100%">
            <Text fontSize="2xl">Welcome to tdt cloud login</Text>
          </Center>
          <Center w="100%" p="5">
            <a href={loginRedirect}>
              <Button bg="green.800" color="white" size="lg" colorScheme="teal">
                Login with Microsoft
                <Image src={microsoft} />
              </Button>
            </a>
          </Center>
        </Box>
      </Box>
    );
    // && userPass != ""
    if (!loggedIn) {
      return (
        <Box bg="green.400" w="100vw" h="100vh">
          {loginIframe}
        </Box>
      );
    } else {
      //<Button p="4">menu</Button>
      /*<MenuButton
                  as={IconButton}
                  aria-label="Options"
                  icon={<HamburgerIcon />}
                  variant="outline"
                  colorScheme="blue"
                />*/
      //console.log(data);
      // onClick={() => this.btnGetVPN()}
      return (
        <Stack w="100%">
          <Menu>
            <Flex p="4">
              <Image src={logo} h="50px" />
              <Spacer />

              <Box pr="4">
                <Text>Welcome {data["displayName"]}</Text>
              </Box>
              <Box bg="green.400">
                <Menu>
                  <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
                    Account
                  </MenuButton>
                  <MenuList>
                    <MenuItem>Logout</MenuItem>
                  </MenuList>
                </Menu>
              </Box>
            </Flex>
          </Menu>
          <Center>
            <Wrap>
              {this.adminUsersBtns()}
              {this.accountUsersBtns()}
              {this.generalAdminBtns()}
              <WrapItem>
                <Button
                  onClick={() => this.btnOldCoursePlanner()}
                  colorScheme={btnCloudPlanner}
                  w="100px"
                  h="60px"
                >
                  <Box>
                    <Center>
                      <CalendarIcon />
                    </Center>
                    <Center>Cloud Planner</Center>
                    <Center>{connectedToCloud}</Center>
                  </Box>
                </Button>
              </WrapItem>

              <WrapItem></WrapItem>
              <WrapItem>
                <Button
                  colorScheme="teal"
                  color="white"
                  w={menuBtnWidth}
                  h={menuBtnHeight}
                  onClick={() => this.btnPressMenu(0)}
                >
                  <Box>
                    <Center>
                      <Icon as={MdCommute} w={8} h={8} />
                    </Center>

                    <Center>Trainers</Center>
                  </Box>
                </Button>
              </WrapItem>

              <WrapItem>
                <Button
                  onClick={() => this.btnPressMenu(4)}
                  colorScheme="teal"
                  w="100px"
                  h="60px"
                >
                  <Box>
                    <Center>
                      <MdSchool />
                    </Center>
                    <Center>PD</Center>
                  </Box>
                </Button>
              </WrapItem>
            </Wrap>
          </Center>
          <Box w="100%" p="3">
            {this.showSelectedWindow()}
          </Box>
        </Stack>
      );
    }
  }
}

/*<dc.SlidePanel
                  id={0}
                  btnOpenStatus={this.btnOpenStatus}
                  isOpen={lstOpen[0]}
                  key={uuidv4()}
                  size="full"
                  content={<>yay</>}
                  //id={uniBtnDay}
                  parentCallback={this.handleCallback}
                  testing={false}
                  side="top"
                  btn1content={
                    <Box>
                      <Center>
                        <Icon as={MdCommute} w={8} h={8} />
                      </Center>

                      <Center>Trainers</Center>
                    </Box>
                  }
                  btn1width="100px"
                  btn1height="60px"
                  btn1cs={btnTrainersColor}
                  btn2content="Back"
                  title={
                    <Center w="100%">
                      <Text>{data["displayName"]}</Text>
                    </Center>
                  }
                />*/

/*<dc.SlidePanel
                  key={uuidv4()}
                  size="full"
                  content={
                    <Calendar
                      //firstname={data["givenName"]}
                      //lastname={data["surname"]}
                      firstname="Michael"
                      lastname="Rinaldi"
                    />
                  }
                  //id={uniBtnDay}
                  parentCallback={this.handleCallback}
                  testing={false}
                  side="top"
                  btn1content={
                    <Box>
                      <Center>
                        <Icon as={MdCommute} w={8} h={8} />
                      </Center>

                      <Center>Trainers</Center>
                    </Box>
                  }
                  btn1width="100px"
                  btn1height="100px"
                  btn1cs="teal"
                  btn2content="Back"
                  title={
                    <Center w="100%">
                      <Stack>
                        <HStack>
                          <Button>
                            <Stack>
                              <Icon as={MdOutlineArrowBackIosNew} w={8} h={8} />
                            </Stack>
                          </Button>
                          <Text>{currentDay}</Text>
                          <Button>
                            <Stack>
                              <Icon as={MdOutlineArrowForwardIos} w={8} h={8} />
                            </Stack>
                          </Button>
                        </HStack>
                      </Stack>
                    </Center>
                  }
                  footer={
                    <Center w="100%">
                      <Stack>
                        <HStack>
                          <Button>
                            <Stack>
                              <Icon as={MdOutlineArrowBackIosNew} w={8} h={8} />
                            </Stack>
                          </Button>
                          <Text>Week {weekNumber}</Text>
                          <Button>
                            <Stack>
                              <Icon as={MdOutlineArrowForwardIos} w={8} h={8} />
                            </Stack>
                          </Button>
                        </HStack>
                      </Stack>
                    </Center>
                  }
                />*/

/*<dc.SlidePanel
                  key={uuidv4()}
                  size="full"
                  content={<Box>yay</Box>}
                  //id={uniBtnDay}
                  parentCallback={this.handleCallback}
                  testing={false}
                  side="top"
                  btn1content={
                    <Box>
                      <Center>VPN</Center>
                      <Center>
                        <LinkIcon />
                      </Center>
                    </Box>
                  }
                  btn1width="100px"
                  btn1height="100px"
                  btn1cs="teal"
                  btn2content="Back"
                  title={<Center>f</Center>}
                />*/

/**/
export default WindowCourse;

/*<Box>
          
          <Box>
            <Center>
              <Wrap spacing="30px">
                <WrapItem>
                  <Center w="180px" h="80px" bg="red.200">
                    Box 1
                  </Center>
                </WrapItem>
                <WrapItem>
                  <Center w="180px" h="80px" bg="green.200">
                    Box 2
                  </Center>
                </WrapItem>
                <WrapItem>
                  <Center w="180px" h="80px" bg="tomato">
                    Box 3
                  </Center>
                </WrapItem>
                <WrapItem>
                  <Center w="180px" h="80px" bg="blue.200">
                    Box 4
                  </Center>
                </WrapItem>
                <WrapItem>
                  <Center w="180px" h="80px" bg="blackAlpha.500">
                    Box 5
                  </Center>
                </WrapItem>
              </Wrap>
            </Center>
          </Box>
        </Box>*/
